namespace Matrix {

    @Serenity.Decorators.registerClass()
    export class SelectableEntityGrid<TItem, TOptions> extends SiteEntityGrid<TItem, TOptions> {

        protected getSlickOptions(): Slick.GridOptions {
            var opt = super.getSlickOptions();
            opt.enableTextSelectionOnCells = true;
            opt.selectedCellCssClass = "slick-row-selected";
            opt.enableCellNavigation = true;
            return opt;
        }

        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }

        get selectedIndexes(): TItem[] {
            return this.slickGrid.getSelectedRows();
        }

        get selectedItems(): TItem[] {
            return this.slickGrid.getSelectedRows().map(x => this.slickGrid.getDataItem(x));
        }
    }

}